import { api } from './base-api';
import {
  ClienteTaxa,
  ClienteTaxasResponse,
  UpdateClienteTaxasPayload,
} from '../../types/cliente-taxa';

const stripDescricao = (t: ClienteTaxa) => {
  const { recebimentoDescricao: _ignored, ...rest } = t;
  return rest;
};

export const clienteTaxasApi = {
  async list(clienteId: string): Promise<ClienteTaxasResponse> {
    const { data } = await api.get<ClienteTaxasResponse>(
      `/admin/clientes/${clienteId}/taxas`,
    );
    return data;
  },

  async update(
    clienteId: string,
    payload: UpdateClienteTaxasPayload,
  ): Promise<ClienteTaxasResponse> {
    const sanitized = { taxas: payload.taxas.map(stripDescricao) };
    const { data } = await api.patch<ClienteTaxasResponse>(
      `/admin/clientes/${clienteId}/taxas`,
      sanitized,
    );
    return data;
  },
};
